module.exports = __webpack_public_path__ + "static/media/shield_microcontroller_green.67c25b2d.svg";